import { sortBy } from 'lodash';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    FormStore,
    inject,
    Input,
    Loader,
    Modal,
    ModalHandle,
    SelectInput,
    TasksStore,
    uuidv4generate,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';
import { Button, Form, FormGroup } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { PartsStore } from './PartsStore';

interface ISelectOption {
    value: string;
    label: string;
}

export interface IRemovePartParams {
    part: Mri.Parts.Part;
    topLevelGuid: string;
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class RemovePartModal extends React.Component<IRemovePartParams> {
    public render() {
        return (
            <Modal title={this.title} modalHandle={this.props.modalHandle} footer={this.footer} bodyClass="p-0 vh-30">
                <div className="p-4">
                    <div>Are you sure you want to remove {this.props.part.serialNumber} from it's assembly?</div>
                </div>
            </Modal>
        );
    }

    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.submitAsync} disabled={this.loading}>
                <Loader loading={this.loading} showSpinner message={'Removing Part...'} />
                {!this.loading && 'Yes'}
            </Button>
        );
    }

    @bind
    @action
    private async submitAsync() {
        this.loading = true;
        const task = this.tasksStore.startSessionTask('Remove Part');

        try {
            await this.partsStore.removePartAsync(this.props.part, this.props.part.partGuid);
            await this.partsStore.loadPartsFromGuid(this.props.topLevelGuid, true);

            task.complete();
            this.props.modalHandle.close();
        } catch (e: any) {
            task.error(e);
        } finally {
            this.loading = false;
        }
    }
    private title = (
        <span className="text-header fw-bold">
            <BsFileEarmark /> Remove Part
        </span>
    );

    @observable private loading = false;

    @computed
    private get userId() {
        return this.accountStore.user!.id;
    }

    @inject private readonly partsStore!: PartsStore;
    @inject private tasksStore!: TasksStore;
    @inject private readonly accountStore!: AccountStore;
}
